if (!window.Eurus.loadedScript.has('cart-noti.js')) {
  window.Eurus.loadedScript.add('cart-noti.js');

  requestAnimationFrame(() => {
    document.addEventListener('alpine:init', () => {
      Alpine.store('xCartNoti', {
        enable: false,
        listItem: [],
        show: false,
        qty: null,
        timer: null,
        setItem(items, qty) {
          this.listItem = [];
          this.qty = qty || null;
          if (items.items) {
            this.listItem = items.items
          } else {
            this.listItem.push(items);
          }
          this.open();
        },
        open() {
          this.show = true;
          clearTimeout(this.timer);
          this.timer = setTimeout(() => {
            this.show = false;
          }, 5000);
        }
      })
    });
  });
}